<template>
  <!-- 自媒体传播指数  -->
  <div class="wlmq_ziBroad_container">
    <div class="head">
      <div class="head_title">
        <img src="../../../assets/Uram/Wemedia/articleLogo_02.png" />{{ title }}
      </div>
      <div class="head_logo">
        <img src="../../../assets/Uram/Wemedia/articleLogo.png" />
      </div>
    </div>
    <div class="body">
      <div
        class="box"
        v-for="(item, index) in mainArr"
        :key="index"
        :class="index == bigIndex ? 'show-big' : ''"
      >
        <div class="box-header">
          <span class="box-title">{{ item }}</span>
          <span class="box-btns">
            <span
              class="btn-box"
              :class="checkId == 1 ? 'activeIcon' : ''"
              @click="sx(index)"
            >
              <i class="iconfont icon-guangxi-shuaxin" id="icon1"></i>
            </span>
            <span
              class="btn-box"
              v-if="show == true"
              :class="checkId == 2 ? 'activeIcon' : ''"
              @click="fullScreen(item, index)"
            >
              <i class="iconfont icon-fangda" id="icon3"></i>
            </span>
            <span
              class="btn-box"
              v-else
              :class="checkId == 2 ? 'activeIcon' : ''"
              @click="smallScreen(item, index)"
            >
              <i class="iconfont icon-suoxiao"></i>
            </span>
          </span>
        </div>
        <ziBroadOne class="ifr" v-if="index == 0" ref="ziBroadOne"></ziBroadOne>
        <ziBroadTwo class="ifr" v-if="index == 1" ref="ziBroadTwo"></ziBroadTwo>
        <ziBroadThr class="ifr" v-if="index == 2" ref="ziBroadThr"></ziBroadThr>
        <ziBroadFou class="ifr" v-if="index == 3" ref="ziBroadFou"></ziBroadFou>
        <ziBroadFiv class="ifr" v-if="index == 4" ref="ziBroadFiv"></ziBroadFiv>
        <ziBroadSix class="ifr" v-if="index == 5" ref="ziBroadSix"></ziBroadSix>
        <ziBroadSev class="ifr" v-if="index == 6" ref="ziBroadSev"></ziBroadSev>
      </div>
    </div>
  </div>
</template>

<script>
import ziBroadOne from "./wlmq_ziBroadOne";
import ziBroadTwo from "./wlmq_ziBroadTwo";
import ziBroadThr from "./wlmq_ziBroadThr";
import ziBroadFou from "./wlmq_ziBroadFou";
import ziBroadFiv from "./wlmq_ziBroadFiv";
import ziBroadSix from "./wlmq_ziBroadSix";
import ziBroadSev from "./wlmq_ziBroadSev";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      title: "自媒体传播指数",
      mainArr: [
        "红山网",
        "乌鲁木齐零距离",
        "974交通广播",
        "UTV大事小事",
        "红山眼APP",
        "乌鲁木齐电视台在路上栏目",
        "FM1007新闻广播",
      ],
      checkId: "1",
      //图标
      icon1: "",
      icon2: "",
      icon3: "",
      checkId: "1",
      //fangda
      bigIndex: -1,
      bigItem: "",
      show: true,
      big_ref: "",
      //
      big_index: "-1",
      //刷新
      sxShow: "false",
    };
  },
  components: {
    ziBroadOne,
    ziBroadTwo,
    ziBroadThr,
    ziBroadFou,
    ziBroadFiv,
    ziBroadSix,
    ziBroadSev,
  },
  created() {},
  mounted() {
    const self = this;
    window.addEventListener("resize", function() {
      setTimeout((_) => {
        try {
          self.$refs.ziBroadOne[0].resize();
          self.$refs.ziBroadTwo[0].resize();
          self.$refs.ziBroadThr[0].resize();
          self.$refs.ziBroadFou[0].resize();
          self.$refs.ziBroadFiv[0].resize();
          self.$refs.ziBroadSix[0].resize();
          self.$refs.ziBroadSev[0].resize();
        } catch (e) {
          //TODO handle the exception
        }
      }, 300);
    });
  },
  methods: {
    sx(index) {
      this.checkId = 1;

      console.log(this.sxShow);
      switch (index) {
        case "0":
          this.$refs.ziBroadOne[0].getEcharts();
          break;

        case "1":
          this.$refs.ziBroadTwo[0].getEcharts();
          break;

        case "2":
          this.$refs.ziBroadThr[0].getEcharts();
          break;

        case "3":
          this.$refs.ziBroadFou[0].getEcharts();
          break;

        case "4":
          this.$refs.ziBroadFiv[0].getEcharts();
          break;

        case "5":
          this.$refs.ziBroadSix[0].getEcharts();
          break;

        case "6":
          this.$refs.ziBroadSev[0].getEcharts();
          break;

        default:
          break;
      }
    },
    //全屏
    fullScreen(item, index) {
      this.checkId = 2;
      this.bigIndex = index;
      this.bigItem = item;
      // this.big_ref=item
      this.show = false;
      setTimeout((_) => {
        // this.resize();
        switch (index) {
          case 0:
            this.$refs.ziBroadOne[0].resize();
            break;

          case 1:
            this.$refs.ziBroadTwo[0].resize();
            break;

          case 2:
            this.$refs.ziBroadThr[0].resize();
            break;

          case 3:
            this.$refs.ziBroadFou[0].resize();
            break;

          case 4:
            this.$refs.ziBroadFiv[0].resize();
            break;

          case 5:
            this.$refs.ziBroadSix[0].resize();
            break;

          case 6:
            this.$refs.ziBroadSev[0].resize();
            break;

          default:
            break;
        }
      }, 500);
      // console.log(this.$refs.ziBroadOne[0])
    },
    smallScreen(item, index) {
      this.bigItem = "";
      this.checkId = 1;
      this.bigIndex = -1;
      setTimeout((_) => {
        this.bigIndex = -1;
        switch (index) {
          case 0:
            this.$refs.ziBroadOne[0].resize();
            break;

          case 1:
            this.$refs.ziBroadTwo[0].resize();
            break;

          case 2:
            this.$refs.ziBroadThr[0].resize();
            break;

          case 3:
            this.$refs.ziBroadFou[0].resize();
            break;

          case 4:
            this.$refs.ziBroadFiv[0].resize();
            break;

          case 5:
            this.$refs.ziBroadSix[0].resize();
            break;

          case 6:
            this.$refs.ziBroadSev[0].resize();
            break;

          default:
            break;
        }
      }, 500);
      this.show = true;
      // console.log(this.bigIndex)
    },
  },
};
</script>

<style lang="scss">
.wlmq_ziBroad_container {
  .main {
    .seven {
      .content {
        .el-radio {
          //未选中文字颜色
          color: #fff;
        }
        .el-radio + .el-radio {
          //按钮距离
          margin-left: 18px;
        }
        .el-radio__inner {
          //圆按钮大小
          width: 12px;
          height: 12px;
        }
        .el-radio__label {
          //文字大小
          font-size: 12px;
          padding-left: 5px; //按钮和文字间距离
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.wlmq_ziBroad_container {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/Uram/Wemedia/expert_bg_img.jpg");
  background-size: 100% 100%;
  position: relative;
  .head {
    width: 100%;
    height: 9.5vh;
    display: flex;
    color: #fff;
    .head_title {
      font-weight: bold;
      font-size: 2vw;
      line-height: 2.8;
      width: 19%;
      margin-left: 4.3%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      img {
        vertical-align: middle;
        width: 13.27%;
        height: 4.84vh;
        margin-right: 2.2%;
      }
    }
    .head_logo {
      width: 8.67%;
      height: 4.44vh;
      position: absolute;
      top: 4vh;
      right: 4%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .body {
    .box {
      width: 22.8vw;
      height: 40.8vh;
      background: url("../../../assets/Uram/Wemedia/zi_bg.png");
      background-size: 100% 100%;
      position: absolute;
      transition: all 0.5s;
      top: 11.9vh;
      left: 2.8vw;
      .box-header {
        /*border: 1px solid #fff;*/
        // box-sizing: border-box;
        display: flex;
        height: 3.15vh;
        line-height: 3.15vh;
        margin-top: 4px;
        color: #fff;
        .box-title {
          font-size: 0.93vw;
          margin-left: 0.93vw;
          color: rgba(0, 191, 255, 1);
          width: 32%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .box-btns {
          position: absolute;
          right: 18px;
          top: 8px;
          .btn-box {
            border: 1px solid #0078d7;
            border-radius: 50%;
            width: 1.25vw;
            height: 1.25vw;
            display: inline-flex;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            .iconfont {
              color: #0374de;
              font-size: 0.78vw;
              position: relative;
              top: 1px;
            }
          }
          .activeIcon {
            background: #009afb;
            color: #fff;
            #icon1,
            #icon2,
            #icon3 {
              color: #fff;
            }
          }
          .small {
            display: none;
          }
        }
      }
    }
    .box:nth-child(2) {
      left: 26.7vw;
    }
    .box:nth-child(3) {
      left: 50.6vw;
    }
    .box:nth-child(4) {
      left: 74.5vw;
    }
    //下面3个
    .box:nth-child(5) {
      top: 54.5vh;
    }
    .box:nth-child(6) {
      top: 54.5vh;
      left: 26.7vw;
    }
    .box:nth-child(7) {
      top: 54.5vh;
      left: 50.6vw;
    }
    //
    .big-box {
      z-index: 88;
    }
    .show-big {
      z-index: 88;
      background: url("../../../assets/Uram/Wemedia/big.png") !important;
      background-size: 100% 100% !important;
      width: 98.18vw !important;
      height: 96.57vh !important;
      top: 1.57vh !important;
      left: 0.93vw !important;
      z-index: 99 !important;
      .box-header {
        .box-btns {
          .big {
            display: none;
          }
          .small {
            display: inline-flex;
          }
          .btn-box {
            .icon-suoxiao {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
